/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 점검 출동 요청 주소 검색 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
// img, css etc
// utils
import clog from "../../../utils/logUtils";
import * as CUTIL from "../../../utils/commUtils";
// components
import DaumPostcode from "react-daum-postcode";
/**
 * @brief EHP 점검 출동 요청 주소 검색 컴포넌트
 * @param -
 * @returns react components
 */
function EhpDtlPostCode(props) {
    const popBody = props.popBody;
    const isPopup = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("isPopup")
                ? popBody.props.isPopup
                : null
            : null
        : null;
    const setParentIsPopup = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("setIsPopup")
                ? popBody.props.setIsPopup
                : null
            : null
        : null;
    const setParentAddress = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("setAddress")
                ? popBody.props.setAddress
                : null
            : null
        : null;
    const [address, setAddress] = useState("");
    const [detailAddress, setDetailAddress] = useState("");
    const [zonecode, setZoncode] = useState("");
    function onCompletePost(data) {
        clog("EHP-POSTCODE : " + JSON.stringify(data));
        setAddress(data.address);
        setZoncode(data.zonecode);
    }
    function onClosePostCode(state) {
        clog("ON CLOSE : POST CODE : " + state);
        if (state === 'FORCE_CLOSE') {
            //사용자가 브라우저 닫기 버튼을 통해 팝업창을 닫았을 경우, 실행될 코드를 작성하는 부분입니다.
        }
        else if (state === 'COMPLETE_CLOSE') {
            //사용자가 검색결과를 선택하여 팝업창이 닫혔을 경우, 실행될 코드를 작성하는 부분입니다.
            //oncomplete 콜백 함수가 실행 완료된 후에 실행됩니다.
        }
        setDefaultQuery("");
        setParentAddress(address);
        CUTIL.jsclose_Popup("pop-postcode");
    }
    function onClickSaveAddress(e) {
        setDefaultQuery("");
        setParentIsPopup(false);
        const allAddress = { zonecode: zonecode, address: address, deladdress: detailAddress };
        setParentAddress(allAddress);
        CUTIL.jsclose_Popup("pop-postcode");
    }
    const [defaultQuery, setDefaultQuery] = useState("");
    useEffect(() => {
        setDefaultQuery("");
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-dtlpostcode", className: "popup-layer js-layer layer-out hidden popup-address" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "\uC8FC\uC18C \uCC3E\uAE30"),
                React.createElement("button", { className: "btn btn-close js-close" },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body" },
                React.createElement("div", { className: "frame__address" }, (isPopup) && React.createElement(DaumPostcode
                //style={postCodeStyle}
                , { 
                    //style={postCodeStyle}
                    autoClose: false, onComplete: onCompletePost, 
                    //onClose={onClosePostCode}
                    defaultQuery: defaultQuery })),
                React.createElement("div", { className: "input__address" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC8FC\uC18C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { placeholder: "\uC0C1\uC138 \uC8FC\uC18C\uB97C \uC120\uD0DD\uD558\uC138\uC694.", value: address, readOnly: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0C1\uC138 \uC8FC\uC18C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", placeholder: "\uC0C1\uC138 \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694.", value: detailAddress, onChange: (e) => setDetailAddress(e.target.value) })))))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { type: "button", className: "bg-gray js-close" },
                    React.createElement("span", null, "\uCDE8\uC18C")),
                React.createElement("button", { type: "button", className: "js-close", onClick: (e) => onClickSaveAddress(e) },
                    React.createElement("span", null, "\uC800\uC7A5"))))));
}
export default EhpDtlPostCode;
